import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "fixed inset-0 z-50 overflow-x-hidden vue-modal-background"
};
const _hoisted_2 = {
  class: "bg-gray-50 w-4/12 shadow-lg rounded-sm absolute top-44 right-1/4 px-10 py-8"
};
import UpdateIntro from "./UpdateIntro.vue";
export default {
  __name: 'UpdateIntroModal',
  props: {
    state: {
      type: Object,
      required: true
    },
    alerts: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(UpdateIntro, {
        state: __props.state,
        alerts: __props.alerts
      }, null, 8, ["state", "alerts"])])]);
    };
  }
};